"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _API_searchParamsValue, _API_fetcher, _API_fetch;
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("decentraland-crypto-middleware/lib/types");
const radash_1 = require("radash");
const logger_1 = __importDefault(require("../../entities/Development/logger"));
const identify_1 = require("../auth/identify");
const storage_1 = require("../auth/storage");
const FetchError_1 = __importDefault(require("../errors/FetchError"));
const RequestError_1 = __importDefault(require("../errors/RequestError"));
const base64_1 = require("../string/base64");
const Options_1 = __importDefault(require("./Options"));
class API {
    constructor(baseUrl = '', defaultOptions = new Options_1.default({})) {
        this.baseUrl = '';
        this.defaultOptions = new Options_1.default({});
        _API_fetcher.set(this, null);
        _API_fetch.set(this, (input, init) => {
            if (__classPrivateFieldGet(this, _API_fetcher, "f")) {
                return __classPrivateFieldGet(this, _API_fetcher, "f").call(this, input, init);
            }
            if (typeof fetch !== 'undefined') {
                return fetch(input, init);
            }
            throw new ReferenceError(`fecher is not defined on API, use .setFetcher() to set it`);
        });
        this.baseUrl = baseUrl || '';
        this.defaultOptions = defaultOptions;
    }
    static catch(prom) {
        return prom.catch((err) => {
            logger_1.default.error(err);
            return null;
        });
    }
    static fromPagination({ page, ...data }, options) {
        return {
            ...data,
            limit: options.pageSize,
            offset: (page - 1) * options.pageSize,
        };
    }
    static searchParams(data, options = {}) {
        const params = new URLSearchParams();
        const keys = Object.keys(data);
        for (const key of keys) {
            const value = data[key];
            if (value === undefined || value === null) {
                continue;
            }
            if (Array.isArray(value)) {
                for (const each of value) {
                    params.append(key, __classPrivateFieldGet(this, _a, "m", _API_searchParamsValue).call(this, each, options));
                }
            }
            else {
                params.append(key, __classPrivateFieldGet(this, _a, "m", _API_searchParamsValue).call(this, value, options));
            }
        }
        if (options === null || options === void 0 ? void 0 : options.default) {
            for (const param of Object.keys(options.default)) {
                if (data[param] === options.default[param]) {
                    params.delete(param);
                }
            }
        }
        return params;
    }
    static url(base, path = '', query = {}) {
        if (base.endsWith('/')) {
            base = base.slice(0, -1);
        }
        if (path !== '' && !path.startsWith('/')) {
            path = '/' + path;
        }
        let params = new URLSearchParams(query).toString();
        if (params) {
            if (path.includes('?')) {
                params = '&' + params;
            }
            else {
                params = '?' + params;
            }
        }
        return base + path + params;
    }
    setFetcher(fetcher) {
        __classPrivateFieldSet(this, _API_fetch, fetcher, "f");
        return this;
    }
    url(path, query = {}) {
        return API.url(this.baseUrl, path, query);
    }
    options(options = {}) {
        return new Options_1.default(options);
    }
    /** @deprecated use API.searchParams instead */
    query(qs) {
        if (!qs) {
            return '';
        }
        const params = new URLSearchParams();
        for (const key of Object.keys(qs)) {
            if (qs[key] === null) {
                params.set(String(key), '');
            }
            else if (qs[key] !== undefined) {
                params.set(String(key), String(qs[key]));
            }
        }
        const queryString = params.toString();
        if (!queryString) {
            return '';
        }
        return '?' + queryString;
    }
    async authorizeOptions(path, options = new Options_1.default({})) {
        const config = options.getAuthorization();
        if (config.identity) {
            const identity = (0, storage_1.getCurrentIdentity)();
            if (!(identity === null || identity === void 0 ? void 0 : identity.authChain) && !config.optional) {
                throw new FetchError_1.default(path, options.toObject(), 'Missing identity to autorize the request');
            }
            if (identity === null || identity === void 0 ? void 0 : identity.authChain) {
                options.header('Authorization', 'Bearer ' + (0, base64_1.toBase64)(JSON.stringify(identity.authChain)));
            }
        }
        return options;
    }
    async signOptions(path, options = new Options_1.default({})) {
        const config = options.getAuthorization();
        if (config.sign) {
            const identity = (0, storage_1.getCurrentIdentity)();
            if (!(identity === null || identity === void 0 ? void 0 : identity.authChain) && !config.optional) {
                throw new FetchError_1.default(path, options.toObject(), 'Missing identity to sign the request');
            }
            if (identity === null || identity === void 0 ? void 0 : identity.authChain) {
                const timestamp = String(Date.now());
                const pathname = new URL(this.url(path), 'https://localhost').pathname;
                const method = options.getMethod() || 'GET';
                const metadata = JSON.stringify(options.getMetadata());
                const payload = [method, pathname, timestamp, metadata]
                    .join(':')
                    .toLowerCase();
                const chain = await (0, identify_1.signPayload)(identity, payload);
                chain.forEach((link, i) => options.header(types_1.AUTH_CHAIN_HEADER_PREFIX + i, JSON.stringify(link)));
                options.header(types_1.AUTH_TIMESTAMP_HEADER, timestamp);
                options.header(types_1.AUTH_METADATA_HEADER, metadata);
                return options;
            }
        }
        return options;
    }
    timeoutOption() { }
    async fetch(path, options = new Options_1.default({})) {
        let res;
        let body = '';
        let json = null;
        const url = this.url(path);
        let opt = this.defaultOptions.merge(options);
        opt = await this.authorizeOptions(path, opt);
        opt = await this.signOptions(path, opt);
        const timeout = opt.getTimeout();
        try {
            // timeout 0 automatically returns a Request Timeout
            if ((timeout.timeout && timeout.timeout <= 0) || timeout.timeout === 0) {
                // if timeoutFallback exists, return it
                if ('timeoutFallback' in timeout) {
                    res = new Response(JSON.stringify(timeout.timeoutFallback), {
                        status: 200,
                    });
                }
                else {
                    res = new Response('Request Timeout', { status: 408 });
                }
                // if timeout exceeds 0, then perform the fetch with a timeout
            }
            else if (timeout.timeout) {
                let completed = false;
                const controller = new AbortController();
                // race against fetch and timeout
                res = await Promise.race([
                    __classPrivateFieldGet(this, _API_fetch, "f").call(this, url, opt.toObject({ signal: controller.signal })).then((res) => {
                        completed = true;
                        return res;
                    }),
                    (0, radash_1.sleep)(timeout.timeout).then(() => {
                        // abort fetch in background
                        if (!completed) {
                            controller.abort();
                        }
                        // if timeoutFallback exists, return it
                        if ('timeoutFallback' in timeout) {
                            return new Response(JSON.stringify(timeout.timeoutFallback), {
                                status: 200,
                            });
                        }
                        // if there is no timeoutFallback, return a Request Timeout
                        return new Response('Request Timeout', { status: 408 });
                    }),
                ]);
                // If not timeout was set then just perform the fetch
            }
            else {
                res = await __classPrivateFieldGet(this, _API_fetch, "f").call(this, url, opt.toObject());
            }
        }
        catch (error) {
            throw new FetchError_1.default(url, opt.toObject(), error.message);
        }
        try {
            body = await res.text();
        }
        catch (error) {
            throw new RequestError_1.default(url, opt.toObject(), res, body);
        }
        try {
            json = JSON.parse(body || '{}');
        }
        catch (error) {
            console.log('parse error', timeout, error);
            throw new RequestError_1.default(url, opt.toObject(), res, error.message + ' at ' + body);
        }
        if (res.status >= 400) {
            throw new RequestError_1.default(url, opt.toObject(), res, json);
        }
        return json;
    }
}
exports.default = API;
_a = API, _API_fetcher = new WeakMap(), _API_fetch = new WeakMap(), _API_searchParamsValue = function _API_searchParamsValue(value, options) {
    if (value instanceof Date) {
        return options.dataToTimestamp ? String(value.getTime()) : value.toJSON();
    }
    return String(value);
};
